import * as React from 'react';

import {
  enumInvoiceStatus,
  InvoiceStatus,
} from '@rematter/frontend-lib-api-client';
import { Badge } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';
import { colorByInvoiceStatus } from '../../utils';

type Props = {
  status: InvoiceStatus;
};

//
// ⚛️ ⚛️ ⚛️ INVOICE STATUS BADGE ⚛️ ⚛️ ⚛️
//
export const InvoiceStatusBadge: React.FC<Props> = ({ status }) => {
  // Translations
  const t = useTranslations();

  const color = colorByInvoiceStatus[status];

  // Memoized values
  const label = React.useMemo(() => {
    switch (status) {
      case enumInvoiceStatus.ProForma:
        return t.invoices.list.status.badge.proForma;
      case enumInvoiceStatus.Pending:
        return t.invoices.list.status.badge.pending;
      case enumInvoiceStatus.Paid:
        return t.invoices.list.status.badge.paid;
      case enumInvoiceStatus.Voided:
        return t.invoices.list.status.badge.voided;
    }
  }, [
    status,
    t.invoices.list.status.badge.proForma,
    t.invoices.list.status.badge.pending,
    t.invoices.list.status.badge.paid,
    t.invoices.list.status.badge.voided,
  ]);

  return (
    <Badge color={color} className="@InvoiceStatusBadge">
      {label}
    </Badge>
  );
};
